import axios from './axios'

export const get = async (service) => {
    try {
        return await axios.get(`/romons.game/api/${service}`)
    } catch (error) {
        throw error
    }
}

export const getPubgById = async (pubgid) => {
    try {
        return await axios.get(`/romons.gameservice/api/game/getpubgbyid/${pubgid}`)
    } catch (error) {
        throw error
    }
}

export const save = async (data) => {
    try {
        return await axios.post(`romons.game/api/games/save`, data)
    } catch (error) {
        throw error
    }
}

export const reorder = async (data) => {
    try {
        return await axios.post(`romons.game/api/games/reorder`, data)
    } catch (error) {
        throw error
    }
}